// Pre-render placeholder shown in the shadow root while organization_metadata is being
// fetched. organization_metadata can take several seconds on a Cloud Run cold start,
// and theme_json (which carries the org's brand color) lives inside that response —
// so we fall back to default_theme, which is overridden at build time via
// __DATA_HUB_BUILD_DEFAULT_THEME_JSON__ for org-specific bundles.
import { default_theme } from '../../helpers/static_vars';

const SKELETON_CLASS = 'data-hub-loading-skeleton';
// Smallest realistic single-row form (e.g. email + submit). The same floor is
// applied to .data_hub_most_parent_container in html_element.css so the swap
// from skeleton to rendered form doesn't shrink the host.
const SKELETON_MIN_HEIGHT_PX = 80;

function inject_loading_skeleton(shadowRoot) {
    if (!shadowRoot || shadowRoot.querySelector('.' + SKELETON_CLASS)) return;

    const spinner_color = default_theme?.primary_brand_color?.[600] || '#2563eb';

    const wrapper = document.createElement('div');
    wrapper.className = SKELETON_CLASS;
    wrapper.setAttribute('aria-busy', 'true');
    wrapper.setAttribute('aria-live', 'polite');
    wrapper.setAttribute('role', 'status');
    wrapper.style.cssText = [
        'display:flex',
        'align-items:center',
        'justify-content:center',
        'width:100%',
        `min-height:${SKELETON_MIN_HEIGHT_PX}px`,
        'box-sizing:border-box',
        'padding:16px',
        'font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif',
    ].join(';');

    wrapper.innerHTML = `
        <style>
            @keyframes data-hub-skeleton-spin { to { transform: rotate(360deg); } }
            @keyframes data-hub-skeleton-fade-in { from { opacity: 0; } to { opacity: 1; } }
            .${SKELETON_CLASS} > svg {
                animation: data-hub-skeleton-spin 0.9s linear infinite;
                transform-origin: center;
                opacity: 0;
                animation-name: data-hub-skeleton-spin, data-hub-skeleton-fade-in;
                animation-duration: 0.9s, 0.6s;
                animation-timing-function: linear, ease-out;
                animation-iteration-count: infinite, 1;
                animation-fill-mode: none, forwards;
                animation-delay: 0s, 0.15s;
            }
        </style>
        <svg width="36" height="36" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Loading form">
            <circle cx="16" cy="16" r="13" stroke="#e5e7eb" stroke-width="3"/>
            <path d="M29 16a13 13 0 0 0-13-13" stroke="${spinner_color}" stroke-width="3" stroke-linecap="round"/>
        </svg>
    `;
    shadowRoot.appendChild(wrapper);
}

export { inject_loading_skeleton };
